/**
 * Client-side gate for Problem Library UI (Epic 5).
 * Mirrors backend PROBLEM_INTELLIGENCE_READ_ENABLED — fail closed.
 *
 * Hides navigation and blocks route shell; does not authorize.
 * Server still answers 404 when the read flag is off.
 */

function parseEnvFlag(value) {
  return String(value || 'false').trim().toLowerCase() === 'true';
}

/** @returns {boolean} */
export function isProblemIntelligenceReadUiEnabled() {
  return parseEnvFlag(process.env.REACT_APP_PROBLEM_INTELLIGENCE_READ_ENABLED);
}
